import React from 'react';
import { Row } from 'antd';
import { useTranslation } from 'react-i18next';

import Dropdown from '../../../../common/Dropdown';
import { getFieldsByType } from '../../../helpers';

import FIELD_TYPES from '../../../../../configs/fieldTypes';
import viewSettingsActions from '../../../../../actions/viewSettingsActions';
import { VIEW_MODES, SETTINGS_KEYS } from '../../../../../configs/viewSettings';

import styles from '../config.less';

const DateSetting = (props) => {
  const { t } = useTranslation();

  if (!props.settings) {
    return null;
  }

  const savedValue = props.settings.getIn([props.name, SETTINGS_KEYS.FIELD_ID]);
  const fallbackValue = props.name === SETTINGS_KEYS.CALENDAR_START ? (getFieldsByType(props.fields, FIELD_TYPES.DATE)[0]?.key || null) : null;
  const value = savedValue || fallbackValue;
  let items = getFieldsByType(props.fields, FIELD_TYPES.DATE);

  if (props.name === SETTINGS_KEYS.CALENDAR_END) {
    const startFieldId = props.settings.getIn([SETTINGS_KEYS.CALENDAR_START, SETTINGS_KEYS.FIELD_ID]);
    items = items.filter((item) => item.key !== startFieldId);
  }

  const handleChange = (selectedItem) => {
    const fieldId = selectedItem ? selectedItem.key : null;
    const option = fieldId ? { type: 'field', fieldId } : null;
    viewSettingsActions.setOption({
      catalogId: props.catalogId,
      viewId: props.viewId,
      viewMode: VIEW_MODES.CALENDAR,
      option: props.name,
      value: option,
    });
  };

  return items ? (
    <Row className={styles.controlRow}>
      <label className={styles.controlLabel}>{t(`calendar.config.${props.name}`)}</label>
      <Dropdown
        disabled={!items.length}
        items={props.name === 'end' ? [{ key: null, text: '', sort: -1 }, ...items] : items}
        value={value}
        autocomplete
        withButton
        multiselect={false}
        onSelectItems={([item]) => handleChange(item)}
      />
    </Row>
  ) : null;
};

export default DateSetting;
